import PropTypes from 'prop-types';
import React from 'react';
import clsx from 'clsx';
import Glyphicon from '../Glyphicon/index.js';
import Text from '../Text/index.js';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const renderStar = _ref => {
  let {
    index,
    percent,
    color
  } = _ref;
  const iconContainerStyle = {
    display: 'inline-block',
    position: 'absolute',
    overflow: 'hidden',
    top: 0,
    left: 0,
    width: `${percent}%`
  };
  const style = {
    display: 'inline-block',
    position: 'relative'
  };
  const starStyle = {
    fontSize: '1em'
  };
  const starStyleWithColor = {
    fontSize: '1em',
    color
  };
  return /*#__PURE__*/_jsxs("span", {
    style: style,
    children: [/*#__PURE__*/_jsx(Glyphicon, {
      style: starStyle,
      glyph: "star",
      className: "text-gray-light"
    }), /*#__PURE__*/_jsx("span", {
      style: iconContainerStyle,
      children: /*#__PURE__*/_jsx(Glyphicon, {
        style: starStyleWithColor,
        glyph: "star"
      })
    })]
  }, index);
};
const renderSingleStar = function (value, color) {
  if (value === void 0) {
    value = 0;
  }
  const decimalValue = Number.parseFloat(value).toFixed(1);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Glyphicon, {
      glyph: "star",
      className: "margin-right-1",
      style: {
        color
      }
    }), /*#__PURE__*/_jsx("span", {
      className: "text-bold text-subdued",
      children: decimalValue
    })]
  });
};
const renderMultipleStars = function (value, maxValue, color, showRating) {
  if (value === void 0) {
    value = 0;
  }
  if (maxValue === void 0) {
    maxValue = 5;
  }
  if (color === void 0) {
    color = '#cfd4da';
  }
  if (showRating === void 0) {
    showRating = false;
  }
  const fullStars = Math.floor(value);
  const renderAllStars = Array(maxValue).fill({}).map((star, index) => {
    let percent;
    // Calculate each symbol's fullness percentage
    if (index - fullStars < 0) {
      percent = 100;
    } else if (index - fullStars === 0) {
      percent = (value - index) * 100;
    } else {
      percent = 0;
    }
    return renderStar({
      index,
      percent,
      color
    });
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [renderAllStars, showRating && /*#__PURE__*/_jsx(Text, {
      weight: "bold",
      className: "margin-left-2",
      children: Number(value).toFixed(1)
    })]
  });
};

/**
 * StarRating generates a read-only rating component that will display a rating as a percentage of active stars.
 *
 */
function StarRating(_ref2) {
  let {
    className,
    value = 0,
    maxValue = 5,
    uiContext = 'five-stars',
    color = '#e85b00',
    showRating = false,
    ...rest
  } = _ref2;
  const rootClassName = clsx('display-inline-block', className);
  const renderedStarRating = uiContext === 'single-star' ? renderSingleStar(value, color) : renderMultipleStars(value, maxValue, color, showRating);
  return /*#__PURE__*/_jsx("span", {
    "data-cmp": "starRating",
    className: rootClassName,
    ...rest,
    children: renderedStarRating
  });
}
export default StarRating;